"use strict";
/*
 * Created on 02 08 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../../core/utils/index");

var StrategyGraphData_1 = require("../model/StrategyGraphData");

var StrategyGraphDataConverter_1 = require("./StrategyGraphDataConverter");
/**
 * @author Jaroslav Sevcik
 */


var StrategyGraphDataConverterImpl =
/*#__PURE__*/
function (_StrategyGraphDataCon) {
  _inherits(StrategyGraphDataConverterImpl, _StrategyGraphDataCon);

  function StrategyGraphDataConverterImpl() {
    _classCallCheck(this, StrategyGraphDataConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(StrategyGraphDataConverterImpl).apply(this, arguments));
  }

  _createClass(StrategyGraphDataConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        profit: source.profit,
        revenue: source.revenue,
        quantity: source.quantity,
        margin: source.margin
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new StrategyGraphData_1.StrategyGraphData(conversions.asObject(source, 'profit', function (v) {
        return index_1.Utils.asNumber(v);
      }), conversions.asObject(source, 'revenue', function (v) {
        return index_1.Utils.asNumber(v);
      }), conversions.asObject(source, 'quantity', function (v) {
        return index_1.Utils.asNumber(v);
      }), conversions.asObject(source, 'margin', function (v) {
        return index_1.Utils.asNumber(v);
      }));
    }
  }]);

  return StrategyGraphDataConverterImpl;
}(StrategyGraphDataConverter_1.StrategyGraphDataConverter);

exports.StrategyGraphDataConverterImpl = StrategyGraphDataConverterImpl;